// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Слухання» (Hearings, ключ `hearing`, група `committees`). */
export const hearingsManifest: IModuleManifest = {
  key: 'hearing',
  group: 'committees',
  slug: 'hearings',
  prefix: 'HRG',
  name: { en: 'Hearings', uk: 'Слухання' },
  entities: [
    { key: 'hearing', slug: 'hearing', name: { en: 'Hearings', uk: 'Слухання' }, main: true },
    { key: 'hearing_participant', slug: 'hearing-participant', name: { en: 'Hearing Participants', uk: 'Учасники' }, main: false },
    { key: 'hearing_agenda_item', slug: 'hearing-agenda-item', name: { en: 'Hearing Agenda Items', uk: 'Пункти порядку денного' }, main: false },
    { key: 'hearing_invitation', slug: 'hearing-invitation', name: { en: 'Hearing Invitations', uk: 'Запрошення' }, main: false },
    { key: 'hearing_transcript', slug: 'hearing-transcript', name: { en: 'Hearing Transcripts', uk: 'Стенограми' }, main: false },
    { key: 'hearing_status', slug: 'hearing-status', name: { en: 'Hearing Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/hearingsSlice').then((m) => m.hearingsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
